import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type PostCollectionIssueHistoryExportRequest = {
  addressUnitNo: string;
  addressStreetNo: string;
  addressStreetName: string;
  addressSuburbName: string;
  addressStateCode: string;
  addressPostCode: string;
  addressCountry: string;
};

export const postCollectionIssueHistoryExport = async (request: PostCollectionIssueHistoryExportRequest) => {
  const response = await executeApiRequest(() => axios.post<Blob>(`/collectionissuehistory/export`, request));

  const blobData = new Blob([response.data]);
  const url = window.URL.createObjectURL(blobData);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `Issue History.csv`);
  document.body.appendChild(link);
  link.click();

  return response;
};
